import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
const Styles = require('./Redirect.css')

@CSSModules(Styles, {allowMultiple:true})
export default class Redirect extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  //
  constructor(props) {
    super(props)
    this.state = { location: props.location }
  }
  //
  componentWillReceiveProps(nextProps) {
    this.setState({location: nextProps.location})
  }
  //
  getRedirectPath = (r) =>{
    return {
      '/macroclimate-30': '/macroclimate-50',
    }[r] || '/not-found-404'
  }
  //
  windowRedirect = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/blog/';
    } else {
      this.context.router.push('/index-funds')
    }
  }
  //
  render() {
    if (this.state.location.pathname == '/university-retirement-plans-funding-destruction-students-future') {
      this.windowRedirect()
    } else {
      this.context.router.push(this.getRedirectPath(this.state.location.pathname))
    }
    return <div />
  }
}
